import { Injectable, Injector, Type } from '@angular/core';
import { IndicatorStore } from '../stores/indicator/indicator.state';
import { CategoryStore } from '../stores/category/category.state';
import { GeoDataStore } from '../stores/geo/geo-data.state';
import { IndicatorDataStore } from '../stores/indicatpr-data/indicator-data.state';
import { RoleStore } from '../stores/role/role.state';
import { BookmarkStore } from '../stores/bookmark/bookmark.state';
import { StoryStore } from '../stores/story/story.state';
import { TagStore } from '../stores/tag/tag.state';
import { UserStore } from '../stores/user/user.state';
import { WorkspaceStore } from '../stores/workspace/workspace.state';
import { DataLayerTypeStore } from '../stores/data-layer-type/data-layer-type.state';
import { DataLayerStore } from '../stores/data-layer/data-layer.state';
import { ColorsetStore } from '../stores/colorset/colorset.state';
import { BookmarkCategoryStore } from '../stores/bookmark-category/bookmark-category.state';
import { TopicStore } from '../stores/topic/topic.state';
import { ComparisonValueStore } from '../stores/comparison-value/comparison-value.state';
import { GridStore } from '../stores/grid/grid.state';
import { GlobalsStore } from '../stores/globals.state';
import { CommuneStore } from '../stores/commune/commune.state';
import { HelpStore } from '../stores/help/help.state';
import { ActiveUserStore } from '../stores/user/active-user.state';
import { NotificationStore } from '../stores/notification/notification.state';

@Injectable({
  providedIn: 'root',
})
export class StoreRegistryService {
  private stores = new Map<string, any>();

  constructor(private injector: Injector) {}

  private createStore<T>(storeType: Type<T>): T {
    return this.injector.get(storeType);
  }

  getStore(entityType: string) {
    if (!this.stores.has(entityType)) {
      switch (entityType) {
        case 'ActiveUser':
          this.stores.set('ActiveUser', this.createStore(ActiveUserStore));
          break;
        case 'Indicator':
          this.stores.set('Indicator', this.createStore(IndicatorStore));
          break;
        case 'Category':
          this.stores.set('Category', this.createStore(CategoryStore));
          break;
        case 'Bookmark':
          this.stores.set('Bookmark', this.createStore(BookmarkStore));
          break;
        case 'BookmarkCategory':
          this.stores.set(
            'BookmarkCategory',
            this.createStore(BookmarkCategoryStore)
          );
          break;
        case 'Colorset':
          this.stores.set('Colorset', this.createStore(ColorsetStore));
          break;
        case 'ComparisonValue':
          this.stores.set(
            'ComparisonValue',
            this.createStore(ComparisonValueStore)
          );
          break;
        case 'DataLayer':
          this.stores.set('DataLayer', this.createStore(DataLayerStore));
          break;
        case 'DataLayerType':
          this.stores.set(
            'DataLayerType',
            this.createStore(DataLayerTypeStore)
          );
          break;
        case 'GeoData':
          this.stores.set('GeoData', this.createStore(GeoDataStore));
          break;
        case 'IndicatorData':
          this.stores.set(
            'IndicatorData',
            this.createStore(IndicatorDataStore)
          );
          break;
        case 'Role':
          this.stores.set('Role', this.createStore(RoleStore));
          break;
        case 'Story':
          this.stores.set('Story', this.createStore(StoryStore));
          break;
        case 'Topic':
          this.stores.set('Topic', this.createStore(TopicStore));
          break;
        case 'Tag':
          this.stores.set('Tag', this.createStore(TagStore));
          break;
        case 'User':
          this.stores.set('User', this.createStore(UserStore));
          break;
        case 'Workspace':
          this.stores.set('Workspace', this.createStore(WorkspaceStore));
          break;
        case 'Grid':
          this.stores.set('Grid', this.createStore(GridStore));
          break;
        case 'Commune':
          this.stores.set('Commune', this.createStore(CommuneStore));
          break;
        case 'Help':
          this.stores.set('Help', this.createStore(HelpStore));
          break;
        case 'Notification':
          this.stores.set('Notification', this.createStore(NotificationStore));
          break;
        case 'Globals':
          this.stores.set('Globals', this.createStore(GlobalsStore));
          break;
        // Add cases for other entity types similarly
        default:
          return undefined;
      }
    }
    return this.stores.get(entityType);
  }
}
